const SectionExperiences = Class(
	/**
	 * @lends {SectionExperiences#}
	 */
	{
		menuItem: 'experiences',

		draw() {
			this.node = mkE({
				tag: 'div',
				id: 'SectionExperiences',
				els: [
					{
						tag: 'div',
						className: 'container fade',
						id: 'hero',
						els: [
							{
								tag: 'h1',
								text: t('b2b.exp.h1')
							},
							{
								tag: 'p',
								text: t('b2b.exp.p')
							},
							{
								tag: 'div',
								className: 'hero__btn',
								els: [
									{
										tag: 'a',
										className: 'button button-pink',
										href: D.url('/contact-us?ref=experiences'),
										text: t('b2b.home.hero.btn')
									}
								]
							}
						]
					},
					this._caseStudies = new T.CaseStudies('corporate', {
						apiCall: this.apiCall,
						noTitle: true,
						noSubtitle: true,
						className: 'mb-5 fade'
					}),
					{
						tag: 'div',
						className: 'container mb-5 exp__feedback fade',
						els: [
							{
								tag: 'h2',
								className: 'mb-3',
								text: t('b2b.exp.feedback.title')
							},
							{
								tag: 'div',
								className: 'wrapper',
								els: [
									{
										tag: 'iframe',
										src: `https://www.youtube-nocookie.com/embed/xljiF4WLu1Q?rel=0`,
										attr: {
											frameborder: 0,
											allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
											allowfullscreen: ''
										}
									},
									{
										tag: 'script',
										attr: {type: 'application/ld+json'},
										text: JSON.stringify({
											'@context': 'https://schema.org',
											'@type': 'VideoObject',
											'name': 'Korporatīvie un komandu saliedēšanas pasākumi',
											'description': 'Roadgames korporatīvie pasākumi uzņēmumiem - komandas saliedēšana un team building orientēšanās spēles Latvijā un ārvalstīs. Izvēlieties kādu no Roadgames spēlēm vai izveidojiet unikālu sava uzņēmuma spēli.',
											'thumbnailUrl': [
												'https://i3.ytimg.com/vi/xljiF4WLu1Q/maxresdefault.jpg'
											],
											'uploadDate': '2023-01-11',
											'contentUrl': 'https://www.youtube.com/watch?v=xljiF4WLu1Q&ab_channel=Roadgames',
											'duration': 'PT3M56S'
										})
									}
								]
							}
						]
					},
					this._testimonials = new T.Quotes('corporate', {
						apiCall: this.apiCall,
						className: 'mb-5 fade'
					}),
					new T.TrustedBy({className: 'mb-5 fade', apiCall: this.apiCall}),
					new T.FAQ({
						title: D.Lang.get('b2b.exp.faq.title'),
						prefix: 'b2b.exp.faq',
						className: 'container mb-5 fade'
					})
				]
			}).append(this.layout.ct());

			this.apiCall.call();
		},

		onShow() {
			if (this._caseStudies) {
				this._caseStudies.onShow();
			}
			if (this._testimonials) {
				this._testimonials.onShow();
			}
			this.fadeOnShow();
		},

		onLeave() {
			if (this._caseStudies) {
				this._caseStudies.onLeave();
			}
			if (this._testimonials) {
				this._testimonials.onLeave();
			}
		},

		onScroll() {
			this.fadeOnScroll();
		}
	},
	Section
);

